<script setup lang="ts">
import type { PropType } from 'vue';

import type { AssetSpecValue } from '~/types/asset.type';

defineProps({
    name: { type: String as PropType<TypedTranslateReturn>, required: true },
    value: { type: [String, Number, Boolean, null] as PropType<AssetSpecValue>, required: true },
});
</script>

<template>
    <p v-if="typeof value === 'boolean'" class="flex items-center">
        <UIcon v-if="value" name="lucide:circle-check" class="text-success-500" />
        <UIcon v-else name="lucide:circle-x" class="text-dimmed" />
        <span class="ml-2" :class="{ 'line-through': !value }">{{ name }}</span>
    </p>
    <p v-else-if="value !== null">
        {{ name }}:&nbsp; <span class="text-primary">{{ value }}</span>
    </p>
</template>
